<template>
  <div
    class="lg:z-[100] bg-semantic-surface-container-lowest shadow-lg w-[24rem] p-6 rounded-b-2xl hidden lg:block"
  >
    <div class="flex flex-col gap-2">
      <div
        v-for="(item, index) in currMenu.menu"
        :key="index"
        @mouseover="
          setIconFillColor(item.title, semanticColorLookup('primary.default'))
        "
        @mouseleave="
          setIconFillColor(
            item.title,
            semanticColorLookup('surface.on-surface')
          )
        "
      >
        <NuxtLink
          :to="item.url"
          exact-active-class="bg-semantic-surface-container-high !text-semantic-primary-default"
          class="px-4 py-3 flex justify-between items-center cursor-pointer hover:bg-semantic-primary-container rounded-2xl border border-semantic-util-transparent hover:text-semantic-primary-default text-semantic-surface-on-surface font-bold"
        >
          <span>
            {{ item.title }}
          </span>

          <V2IconsCaret
            class="w-4 h-4"
            direction="right"
            :fill="
              iconFillColor.get(item.title) ||
                semanticColorLookup('surface.on-surface')
            "
          />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismNavBarMegaMenuDesktop'
})

const props = defineProps({
  currMenu: {
    type: Object,
    default: () => ({})
  }
})

const iconFillColor = ref(new Map())

watch(
  () => props.currMenu,
  () => {
    iconFillColor.value.clear()
  }
)

const setIconFillColor = (key, color) => {
  iconFillColor.value.set(key, color)
}
</script>
